import {Navigate} from "react-router-dom";
import ErrorBoundary from "components/layout/router-error-boundary";
import NotFound from "components/pages/not-found";
import Container from "./helpers/container";
import * as Pages from "./pages";

export default function createRoutes() {
  return [{
    children: [
      {element: <Navigate replace={true} to="/admin/admins" />, path: "/admin"},
      {Component: Pages.Admin.Admins.List, path: "/admin/admins"},
      {Component: Pages.Admin.Decks.New, path: "/admin/decks/new"},
      {Component: Pages.Admin.Decks.Edit, path: "/admin/decks/:id/edit"},
      {Component: Pages.Admin.Decks.List, path: "/admin/decks"},
      {Component: Pages.Admin.Organizations.New, path: "/admin/organizations/new"},
      {Component: Pages.Admin.Organizations.Edit, path: "/admin/organizations/:id/edit"},
      {Component: Pages.Admin.Organizations.List, path: "/admin/organizations"},
      {Component: Pages.Admin.SuperAdmin, path: "/admin/super_admin"},
      {Component: Pages.Admin.ValidationAutomatedReports.New, path: "/admin/validation/automated_reports/new"},
      {Component: Pages.Admin.ValidationAutomatedReports.Edit, path: "/admin/validation/automated_reports/:id/edit"},
      {Component: Pages.Admin.ValidationAutomatedReports.List, path: "/admin/validation/automated_reports"},
      {Component: Pages.Admin.ValidationAutomatedReports.Subscription, path: "/admin/validation/automated_reports/:id/subscription"},
      {Component: Pages.Admin.ValidationReports.New, path: "/admin/validation/reports/new"},
      {Component: Pages.Admin.ValidationReports.List, path: "/admin/validation/reports"},
      {Component: Pages.Admin.ValidationStudies.New, path: "/admin/validation/studies/new"},
      {Component: Pages.Admin.ValidationStudies.Edit, path: "/admin/validation/studies/:id/edit"},
      {Component: Pages.Admin.ValidationStudies.List, path: "/admin/validation/studies"},
      {Component: Pages.Admin.ValidationSurveys.New, path: "/admin/validation/surveys/new"},
      {Component: Pages.Admin.ValidationSurveys.Edit, path: "/admin/validation/surveys/:id/edit"},
      {Component: Pages.Admin.ValidationSurveys.List, path: "/admin/validation/surveys"},
      {Component: Pages.Public.Auth, path: "/auth"},
      {Component: Pages.Public.Unauthorized, path: "/unauthorized"},
      {Component: NotFound, path: "*"}
    ],
    Component: Container,
    ErrorBoundary
  }];
}
